<template>
  <ul class="quick-search__list">
    <!-- find a provider -->
    <li class="quick-search__item" aria-label="search for a provider">
      <h2 class="qs__item__header">Find a provider</h2>
      <form class="qs__item__content" @submit.prevent="search(searchType.provider)">
        <label for="findProvider" class="content__label" aria-labelledby="provider icon"><font-awesome-icon icon="user-md" class="icon"/></label>
        <input v-model="searchProvider" type="text" id="findProvider" class="content__input"
               placeholder="Search provider by name or keywords, or leave empty to show all" />
        <button class="content__button" type="submit">Search</button>
      </form>
    </li>

    <!-- find a document -->
    <li class="quick-search__item" aria-label="search for a document">
      <h2 class="qs__item__header">Find a document</h2>
      <form class="qs__item__content" @submit.prevent="search(searchType.document)">
        <label for="findDocument" class="content__label" aria-labelledby="document icon"><font-awesome-icon icon="file-alt" class="icon"/></label>
        <input v-model="searchDocument" type="text" id="findDocument" class="content__input"
               placeholder="Search document by title" />
        <button class="content__button" type="submit">Search</button>
      </form>
    </li>
  </ul>

</template>

<script>
  import {SearchPageNavigation,ResumeFsm} from '@/store/modules/fsm/messages';

  export default {
    name: "WelcomeQuickNavSearch",
    data() {
      return {
        searchQuery: '',
        searchProvider: '',     // can't share the same model with document due to reactivity
        searchDocument: '',
        searchType: {
          provider: 'provider',
          document: 'document',
        }
      }
    },
    methods: {
      search(category) {
        switch (category) {
          case this.searchType.provider:
            this.$router.push({ name: SearchPageNavigation, query: { category: category, query: this.searchProvider }});
            break;
          case this.searchType.document:
            this.$router.push({ name: SearchPageNavigation, query: { category: category, query: this.searchDocument }});
            break;
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "../../../stylesheets/mixins/flex";
  $color-base: #0060ff;
  $color-font: #58595b;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .quick-search__list {
    text-align: left;
    padding: 0 20px;
    color: $color-font;
  }
  .quick-search__item {
    margin-top: 1.5em;
  }
  .qs__item__header {
    font-size: 1.0em;
    margin-bottom: 0.5em;
    font-weight: bold;
  }
  .qs__item__content {
    @include flex-box();
    flex-wrap: wrap;
    font-size: 0.8em;
    align-items: center;

    .content__label {
      @include flex(1, 0, 5%);
      text-align: center;

    }
    .content__input {
      @include flex(1, 0, 70%);
      margin: 0 5px;
    }
    .content__button {
      @include flex(1, 0, 15%);
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 2px;
      padding: 5px 10px;
      cursor: pointer;
    }

  }
  .icon {
    font-size: 2.5em;
    margin-top: 5px;
  }
  @media only screen and (max-width: 768px) {
    .qs__item__content {

      .content__label {
        @include flex(1, 0, 10%);
      }
      .content__input {
        @include flex(1, 0, 85%);
      }
      .content__button {
        @include flex(1, 0, 100%);
        margin-top: 10px;
      }
    }
    .icon {
      font-size: 1.5em;
      margin-top: 10px;
    }
  }
</style>